export enum SalvageRequestTypes {
  'Common Disposal' = 'CommonDisposal',
  'Company Use' = 'CompanyUse',
  'Canada Salvage' = 'MoveToCSV',
  'Regulated Disposal' = 'HazMatRegulatedDisposal',
  'United State Salvage' = 'MoveToCMK',
}
